export default __webpack_public_path__ + "static/media/minimalHorizon.9fc0958b.jpg";